import React from "react";
import TypingAnimation from "./TypingAnimation"; // import the custom TypingAnimation component

export default function Banner() {
  return (
    <section
      id="hero"
      className="d-flex flex-column justify-content-center align-items-center"
    >
      <div className="hero-container" data-aos="fade-in">
        <h1>Ashmin Karki</h1>
        <p>
          I'm
          <TypingAnimation
            textArray={["Software Engineer"]}
            typingSpeed={100}
          />
        </p>
      </div>
    </section>
  );
}
